// ============================================
// COLORES OFICIALES TERAPPY® - IDENTIDAD CORPORATIVA
// Referencia: Manual de Identidad Gráfica Terappy
// ============================================

// Colores de Marca (Brand Colors) - NON-NEGOTIABLE
export const BRAND_BLACK = "#000000";              // Negro Corporativo (CMYK: 91%,79%,62%,97%)
export const BRAND_GREEN_PRIMARY = "#B3CC1D";     // Verde Lima Principal (RGB: 179,204,29)
export const BRAND_GREEN_VIBRANT = "#E0E50A";     // Verde Lima Vibrante (RGB: 224,229,10)
export const BRAND_GREEN_LIGHT = "#EFF284";       // Verde Lima Claro (RGB: 239,242,132)

// Aliases para compatibilidad con código existente
export const PRIMARY_GREEN = BRAND_GREEN_PRIMARY;  // #B3CC1D (CORREGIDO desde #717402)
export const GREEN = BRAND_GREEN_PRIMARY;          // #B3CC1D
export const GOLDEN = BRAND_GREEN_VIBRANT;         // #E0E50A (CORREGIDO desde #E5BE0A)
export const GOLDEN_HIGHLIGHT = BRAND_GREEN_LIGHT; // #EFF284
export const GREEN_HIGHLIGHT = BRAND_GREEN_LIGHT;  // #EFF284 (CORREGIDO desde #C3F284)

// Textos
export const DARK_TEXT = "#484848";
export const DARKER_TEXT = "#313131";
export const PLACEHOLDER_TEXT = "#A5A5A5";

// Estados Base
export const RED = "#cf142b";
export const RED_LIGHT = "#cf142b55";

// Colores de Rol (para badges, chips, avatars)
export const ADMIN_COLOR = "#8B0000";         // Rojo oscuro para admin
export const BUSINESS_COLOR = "#1976d2";      // Azul para business
export const THERAPIST_COLOR = "#717402";     // Verde primario para terapeuta
export const CLIENT_COLOR = "#757575";        // Gris para cliente

// Estados de Aprobación
export const SUCCESS_GREEN = "#2e7d32";       // Aprobado/Activo
export const WARNING_ORANGE = "#ed6c02";      // Pendiente/Advertencia
export const ERROR_RED = "#d32f2f";           // Rechazado/Error
export const INFO_BLUE = "#0288d1";           // Información

// Backgrounds
export const ADMIN_BG = "#f5f5f5";            // Fondo claro admin
export const CARD_BG = "#ffffff";             // Fondo cards
export const DARK_BG = "#2c2c2c";             // Dark mode (futuro)

// Charts & Graphs
export const CHART_PRIMARY = "#717402";       // Verde primario
export const CHART_SECONDARY = "#B3CC1D";     // Verde lima
export const CHART_TERTIARY = "#E5BE0A";      // Dorado
export const CHART_QUATERNARY = "#1976d2";    // Azul
export const CHART_NEGATIVE = "#cf142b";      // Negativo
